<template>
  <div class="card-add-bank-account">
    <ActionBar
      v-for="bank in list"
      :key="bank.bankNo"
      :title="bank.bankShortName"
      :icon-name="BANK_ICON_MAP[bank.bankNo]"
      @click="handleShowDialog(bank.bankNo)"
    />

    <div class="description">
      <md-icon
        class="description-icon"
        name="warn"
        color="#B2B2B2"
        size="sm"
      />

      <p>{{ $t('addNewCardInfo') }}</p>
    </div>

    <md-dialog
      v-model="showDialog"
      :title="$t('addNewBankCard')"
      :closable="true"
      :btns="[{
        text: $t('add_now'),
        handler: handleAddNow,
      }]"
    >
      <ul class="add-dialog">
        <li>
          {{ $t('addDialog1') }}
        </li>
        <li>
          {{ $t('addDialog2') }}
        </li>
        <li>
          {{ $t('addDialog3') }}
        </li>
        <li>
          {{ $t('addDialog4') }}
        </li>
      </ul>
    </md-dialog>
  </div>
</template>

<script>
import ActionBar from '@/components/ActionBar'
import { Icon, Dialog } from 'mand-mobile'
import { getBankList } from '@/api/transfer'
import { BANK_ICON_MAP } from './config'
import { bind } from '@/api/card-add-bank-account'
import openBrowserInExpress from '@/utils/open-browser-in-express'

// 操作环境
const SOURCE_TYPE_ENUM = {
  WALLET_H5: 1, // 钱包
  WALLET_APP: 2 // 钱包APP
}

export default {
  name: 'CardAddBankAccount',

  components: {
    ActionBar,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog
  },

  data () {
    return {
      BANK_ICON_MAP,
      showDialog: false,
      list: [],
      currentBankNo: ''
    }
  },

  computed: {
    sourceType () {
      if (this.$store.getters.isApp) {
        return SOURCE_TYPE_ENUM.WALLET_APP
      } else {
        return SOURCE_TYPE_ENUM.WALLET_H5
      }
    }
  },

  async created () {
    this.list = await getBankList({
      whetherSign: 1
    })
  },

  methods: {
    async handleAddNow () {
      const result = await bind({
        bankNo: this.currentBankNo,
        sourceType: this.sourceType
      })

      // 如果再快递app中
      if (this.sourceType === SOURCE_TYPE_ENUM.WALLET_APP) {
        openBrowserInExpress(result.webUrl)
      } else {
        window.location.href = result.webUrl
      }
    },

    handleShowDialog (no) {
      this.showDialog = true
      this.currentBankNo = no
    }
  }
}
</script>

<style scoped lang="scss">
.card-add-bank-account {
  padding: 40px;
}

.description {
  margin-top: 40px;
  display: flex;
  justify-content: flex-start;
  color: #b2b2b2;

  .description-icon {
    margin-top: 5px;
  }

  > p {
    margin-left: 16px;
    font-size: 24px;
    line-height: 36px;
  }
}

.add-dialog {
  max-width: 460px;
  font-size: 24px;
  color: #999;
  line-height: 36px;
}
</style>
